<template>
    <div id="weixinModal" class="modal fade" v-if="isShow" style="display: block">
        <div class="modal-dialog">
            <div class="QRcode__weixinbg">
                <p class="weixin__login__txt">请用微信扫一扫以下二维码</p>
                <div id="QRcode_container">
                    <img :src="erweima">
                </div>
                <div class="button--closed" @click="close">
                    <img src="../../assets/closed.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'

    export default {
        name: 'BundlingWechat',
        props: {},
        data: () => {
            return {
                isShow: false,
                erweima: '',
                timer: null,
            }
        },
        methods: {
            async show () {
                this.$loading.show()
                const EWM = await this.getErweima()
                this.$loading.hide()
                this.erweima = EWM.url
                this.isShow = true

                this.timer = setInterval(async () => {
                    const wechatData = await this.checkIsScan(EWM.token)
                    if (wechatData.isBinding) {
                        const bindFlag = await this.checkBunding(wechatData.openId)
                        this.$emit('on-bind', bindFlag)
                        clearInterval(this.timer)
                        this.timer = null
                        this.isShow = false
                    }
                }, 2000)
            },
            close () {
                clearInterval(this.timer)
                this.timer = null
                this.$emit('on-bind', false)
                this.isShow = false
            },
            async getErweima () {
                const { errMsg, data, success } = await api.user.getWechatEWM()
                if (success) {
                    return data
                } else {
                    this.$message.show('error', errMsg)
                    return null
                }
            },
            async checkIsScan (token) {
                const { errMsg, data, success } = await api.user.checkIsLogin(token)
                if (success) {
                    return data
                } else {
                    this.$message.show('error', errMsg)
                    return null
                }
            },
            async checkBunding (openId) {
                const { errMsg, success } = await api.user.checkBind(openId)
                if (success) {
                    return true
                } else {
                    this.$message.show('error', errMsg)
                    return false
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    #weixinModal{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        .QRcode__weixinbg{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 400px;
            padding: 10px;
            background: #fff;
            text-align: center;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
        }
    }
    /************************微信二维码************************/

    #weixinModal, #wxunBindModal, #loginModal {
        opacity: 1;
        background: rgba(0, 0, 0, 0.8);
    }

    #weixinModal .modal-dialog, #wxunBindModal .modal-dialog {
        top: 300px;
        width: 400px;
    }

    .QRcode__weixinbg {
        padding: 10px;
        background: #fff;
        text-align: center;
    }

    .weixin__login__txt {
        font-size: 16px;
        margin: 0;
        color: #021256;
    }

    #QRcode_container img {
        width: 60%;
    }

    .button--closed {
        width: 39px;
        position: absolute;
        top: -15px;
        right: -15px;
        cursor: pointer;
    }
</style>
